import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface PrescriptionStoreProps extends CacheProps {
  orderCount: string
  clientContactId: string
  contributors: object
  gender: string
  applicantName?: string
  applicantLastName?: string
  applicantCode?: string
  clientSuggestedType: string
  clientSuggestedTime?: string | undefined
  clientSuggestedRange?: string | undefined
  file: any
  fileComment?: string
}

const prescriptionStoreDataApi = ({ file, fileComment, gender, applicantName, applicantLastName, applicantCode, clientSuggestedType, clientSuggestedTime, clientSuggestedRange, clientContactId, contributors, orderCount, ...rest }: PrescriptionStoreProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.labs.store'],
    payload: {
      order_count: orderCount,
      is_out_of_turn: '0',
      client_contact_id: clientContactId,
      contributors: contributors,
      client: {
        choose_client: '1',
        first_name: applicantName,
        last_name: applicantLastName,
        national_id: applicantCode,
        sex: gender,
      },
      type_test_order: '2',
      client_suggested_type: clientSuggestedType,
      client_suggested_time: clientSuggestedTime,
      client_suggested_range: clientSuggestedRange,
      client_file: file,
      client_comment: fileComment,
    },
    withToken: true,
    ...rest,
  });
};

export default prescriptionStoreDataApi;
